import React, { Component } from 'react';

import Transition from 'react-transition-group/Transition';

import navigation from '../navigation';


const defaultStyle = {
  transition: `all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275)`,
  opacity: 0,
  bottom: "-100px"
}

const transitionStyles = {
  entering: { opacity: 0, bottom: "-100px" },
  entered: { opacity: 1, bottom:"0px" }
};

class WorkComponent extends Component {
	constructor(props) {
		super(props)
		
		// this.getWorkHover = this.getWorkHover.bind(this);

		this.state = {
			hoverItem : false,
			activeItem: null,
			isMobile: false,
			in: false

		}
	}

	componentDidMount() {
		if(window.innerWidth < 700 ){
			this.setState({
				isMobile: true
			})
		}
		window.addEventListener('resize', this.handleResize);
		this.toggleEnterState();
	}

	toggleEnterState = () => {
	  this.setState({ in: true });
	}

	componentWillUnmount(){
	    window.removeEventListener('resize', this.handleResize);
	}

	handleResize = () => {
	    
	    if(window.innerWidth < 700 ){
	    	this.setState({
	    		isMobile: true
	    	})
	    }else{
	    	this.setState({
	    		isMobile: false
	    	})
	    }
	    this.forceUpdate();
	};

	onItemHover(item) {
		if(!this.state.isMobile){
			this.setState({
				hoverItem: true,
				activeItem: item
			})
		}
		
	}
	offItemHover(item) {
		if(!this.state.isMobile){
			this.setState({
				hoverItem: false,
				activeItem: null
			})
		}
		
	}

	logoClickHandler(event, location){
		if(!this.state.isMobile){
			window.open(location, "_blank");
		}else{
			return;
		}
	}


	render(){
		

		const Work = navigation[1].content.map((workPiece, i)=>{
			
			const { client, work, logo } = workPiece;
			
			let linkStyle;
		    if (this.state.hoverItem && i === this.state.activeItem) {
		      linkStyle = {
		      	backgroundImage: "url("+logo+")",
		      	width: "100%",
      			paddingBottom: "100%"
		      }
		    } else {
		      linkStyle = {
		      	backgroundImage: "url("+logo+")",
		      	width: "80%",
      			paddingBottom: "80%"
		      }
		    }
			
		    let contentStyle;
		    if (this.state.hoverItem && i === this.state.activeItem) {
		      contentStyle = {
		      	opacity: "1",
		      	top: "0px"
		      }
		    } else {
		      contentStyle = {
		      	opacity: "0"
		      }
		    }




			return(
				<div className="Work__Container" 
					onMouseEnter={this.onItemHover.bind(this, i)}
					onMouseLeave={this.offItemHover.bind(this)}
					key= {i}>
					<a href="#"  
						className="Work__Icons" 
						onClick={(e)=>{
							e.preventDefault();
							this.props.handleWorkContent(work)

						}}
						style={linkStyle}></a>
				</div>
			)
		})

		return(
			<Transition
			in={this.state.in}
			timeout={300}>
				{
					(state) =>(
						<div className="Work"
						style={{
							...defaultStyle,
							...transitionStyles[state]
						}}
						>
							{ Work }
						</div>
					)		
				}
				
			</Transition>
		)
	}

}

export default WorkComponent;


// WEBPACK FOOTER //
// ./src/components/WorkComponent.js